module.exports = __webpack_public_path__ + "img/FOSUN-FPD-detail.f0031d9b.png";